// extracted by mini-css-extract-plugin
export default {"container":"Report_container__vaQ9z","body":"Report_body__PH5it"};